"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StackedAvatars = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

var _molecules = require("../../molecules");

var _helpers = require("../../util/helpers");

require("./StackedAvatars.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Slobodan Djordjevic
 */
var StackedAvatars = function StackedAvatars(_ref) {
  var users = _ref.users,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight;
  return /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "StackedAvatars"
  }, (users === null || users === void 0 ? void 0 : users.length) === 1 && /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
    key: "avatar-".concat(users[0].user_id),
    size: 40,
    imageUrl: users[0].pic_url,
    initials: (0, _helpers.getInitials)(users[0].first_name, users[0].last_name),
    marginRight: marginRight ? marginRight : "8",
    marginLeft: marginLeft
  }), (users === null || users === void 0 ? void 0 : users.length) > 1 && (users === null || users === void 0 ? void 0 : users.map(function (user, index) {
    var className = "";

    if (index === 1) {
      className = "second-avatar ".concat(users.length === 2 ? "two-avatars-margin" : "");
    } else if (index === 2) {
      className = "third-avatar three-avatars-margin";
    }

    var isAnon = user.user_id ? false : true;
    var avatarKeySuffix = isAnon ? "".concat(index) : "".concat(index, "-").concat(user.user_id);
    var avatarKey = "avatar-".concat(avatarKeySuffix);
    var avatarUrl = isAnon ? (0, _helpers.getAnonAvatarImage)(index) : user.pic_url;
    var initials = isAnon ? "" : (0, _helpers.getInitials)(user.first_name, user.last_name);
    return /*#__PURE__*/_react.default.createElement(_molecules.Avatar, {
      key: avatarKey,
      className: className,
      size: (users === null || users === void 0 ? void 0 : users.length) === 2 ? 32 : 24,
      imageUrl: avatarUrl,
      initials: initials
    });
  })));
};

exports.StackedAvatars = StackedAvatars;